import { ref, computed, watch, getCurrentInstance } from 'vue';
import {
    max_equals_length_var,
    min_equals_length_var
} from '@/helpers';

export default function useVFInput(props, emit) {
    const instance = getCurrentInstance();
    const t = instance ? instance?.proxy?.$t : ((key) => key);

    const size = ref(props.size);
    const valid = ref(props.valid);
    const vfClass = ref(props.vfClass);
    const icon = ref(props.icon);
    const modelValue = ref(props.modelValue);
    const totalyClass = ref(props.totalyClass);
    const minLength = ref(props.minLength);
    const maxLength = ref(props.maxLength);
    const errorMessage = ref('');

    const onGetClasses = (refValid = false) => {
        let sizeValue = size.value ? `form-control-${size.value}` : '';
        let isValidValue = refValid ? '' : 'vf-error';
        return `${sizeValue} ${isValidValue} ${vfClass.value}`;
    };

    const onGetIcon = computed(() => icon.value || '');

    const onHasIcon = computed(() => (icon.value ? 'input-group' : ''));

    const checkAllowedChars = ( value ) => {
        const onlyNumbers = /^\d*$/;
        if (props.allowedChars === 'numbers' && !onlyNumbers.test( value )) {
            errorMessage.value = t('general.inputs.messages.type_number');
            return false;
        }

        const onlyLetters = /^[a-zA-Z\s]*$/;
        if (props.allowedChars === 'letters' && !onlyLetters.test( value )) {
            errorMessage.value = t('general.inputs.messages.type_letter');
            return false;
        }
        return true;
    };

    const checkLength = ( value ) => {
        if (
            value.length && maxLength.value && minLength.value
            && (
                !max_equals_length_var( value.length, minLength.value )
                || !min_equals_length_var( value.length, maxLength.value )
            )
        ) {
            errorMessage.value = t('general.inputs.messages.min_max_length', {
                min: minLength.value,
                max: maxLength.value
            });
            return false;
        }
        return true;
    };

    const isValidInput = ( value ) => {
        if (!checkAllowedChars( value )) return false;
        if (!checkLength( value )) return false;

        errorMessage.value = '';
        return true;
    };

    const onUpdateModelValue = (event) => {
        let value = event.target.value;
        valid.value = isValidInput( value );

        modelValue.value = event.target.value;
        if (event.target.type === 'number') {
            modelValue.value = parseInt(modelValue.value);
        }
        emit('update:modelValue', modelValue.value);
    };

    const onBlurInputNumber = (event) => {
        let newValue = validateAndLimitInputNumber(event.target.value);
        event.target.value = newValue;
        emit('update:modelValue', newValue);
    };

    const validateAndLimitInputNumber = (value) => {
        if (value === '') {
            return parseInt(props.minValue);
        }

        const regex = /^\d+$/;
        if (!regex.test(value) || value < props.minValue) {
            value = props.minValue;
        }

        if (value > props.maxValue) {
            value = props.maxValue;
        }

        return parseInt(value);
    }

    watch(() => props.valid, (newValue) => {
        totalyClass.value = onGetClasses(newValue);
    });

    watch(valid, (newVal) => {
        totalyClass.value = onGetClasses(newVal);
    });

    return {
        errorMessage,
        icon,
        modelValue,
        size,
        totalyClass,
        valid,
        vfClass,
        onBlurInputNumber,
        onGetClasses,
        onGetIcon,
        onHasIcon,
        onUpdateModelValue
    };
}
